<template>
  <v-app>
    <v-main class="print-only-main">
      <router-view />
    </v-main>
  </v-app>
  
</template>

<script>
export default { name: 'PrintLayout' };
</script>

<style scoped>
.print-only-main {
  background: #fff;
}
@media print {
  @page { size: A4 landscape; }
}
</style>


